import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "../../components/form-components.module";
import { UpdateInstitutionComponent } from "./update-institution.component";
import { HttpService } from "src/providers/http.service";
import { RouterModule } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { AgmCoreModule } from "@agm/core";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HttpClientModule } from '@angular/common/http';
import { ColorPickerModule, ColorPickerService } from 'ngx-color-picker';
// import { CalendarComponent } from "../../components/default-calendar/default-calendar";
// import { DefaultTableComponent } from "../components/form-components.module";

@NgModule({
  imports: [
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyA8Wl_WxvljN8tzUh_kapOWOPSZRSGeGv4"
    }),
    ComponentsModule,
    MatCardModule,
    RouterModule,
    CommonModule,
    MatCheckboxModule,
    HttpClientModule,
    ColorPickerModule
  ],
  declarations: [UpdateInstitutionComponent],
  exports: [UpdateInstitutionComponent],
  providers: [HttpService, ColorPickerService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class UpdateInstitutionModule { }
